import './multicolumnListDirective.scss';

export const MulticolumnListDirective = function () {
    return {
        restrict: 'E',
        scope: {},
        transclude: {
            'listOne': 'listOne',
            'listTwo': 'listTwo'
        },
        template: require('./multicolumnListDirective.html')
    }
};